import { z } from 'zod';

import { httpGetAdapter } from '@/lib/adapters/httpGetAdapter';
import { categoriesResponseSchema, type CategoriesResponse } from '@/schemas/category';

export const getCategoriesParamsSchema = z.object({
  schoolId: z.number(),
});

export type GetCategoriesParams = z.infer<typeof getCategoriesParamsSchema>;

export const getCategories = httpGetAdapter<CategoriesResponse, GetCategoriesParams>({
  url: '/v2/categorias/ativas',
  schema: categoriesResponseSchema,
  mapParams: (params) => ({
    escolaId: params.schoolId,
  }),
});
